export const DEFAULT_ROUTES = [
	{
		name: 'Announcements',
		type: 'announcements',
		path: '/announcements',
		isDisabled: false,
		icon: 'megaphone',
		active: true,
	},
	{
		name: 'Agenda',
		type: 'agenda',
		path: '/agenda',
		isDisabled: false,
		icon: 'calendar',
		active: false,
	},
	{
		name: 'Social Feed',
		type: 'feed',
		path: '/feed',
		isDisabled: false,
		icon: 'chats',
		active: false,
	},
	{
		name: 'Materials',
		type: 'materials',
		path: '/materials',
		isDisabled: false,
		icon: 'folders',
		active: false,
	},
	{
		name: 'Directory',
		type: 'directory',
		path: '/directory',
		isDisabled: false,
		icon: 'contacts',
		active: true,
	},
	{
		name: 'Notifications',
		type: 'notifications',
		path: '/notifications',
		isDisabled: false,
		icon: 'notification',
		active: false,
	},

	{
		name: 'Scan QR',
		type: 'scanQR',
		path: '/scanQR',
		isDisabled: false,
		icon: 'camera',
		active: false,
	},
	// {
	// 	name: 'Profile',
	// 	type: 'attendeeDetail',
	// 	path: '/attendeeDetail',
	// 	isDisabled: false,
	// 	icon: 'user',
	// 	active: false,
	// },
	{
		name: 'Settings',
		type: 'settings',
		path: '/settings',
		isDisabled: false,
		icon: 'settings',
		active: true,
	},
	{
		name: 'Podcasts',
		type: 'podcasts',
		path: '/podcasts',
		isDisabled: false,
		icon: 'microphone',
		active: false,
	},
];

export const DEFAULT_ROUTES_STR = JSON.stringify({ routes: DEFAULT_ROUTES, other: [] });
